<template>
    <div class="supsis-table" :class="{ 'zebra-row': zebraRow }">
        <div class="supsis-table-options" :class="['align-' + headAlign]" v-if="topPagination">
            <ve-pagination
                class="custom-pagination"
                v-if="topPagination"
                :total="cursor.total"
                :page-index="cursor.page"
                :page-size="cursor.perPage"
                :page-size-option="paginationOptions"
                @on-page-number-change="pageNumberChange"
                @on-page-size-change="perPageNumberChange"
            />
        </div>
        <slot name="header" v-if="isSlotHas('header')" />
        <div>
            <ve-table :columns="reFormatedColumns" :table-data="rows" style="word-break: break-word" v-bind="params" />
            <div
                class="supsis-table-empty-data"
                :class="{ bordered: emptyDataBordered }"
                v-if="isSlotHas('emptyData') && rows.length <= 0"
            >
                <slot name="emptyData" />
            </div>
        </div>
        <slot name="footer" v-if="isSlotHas('footer')" />
        <div class="supsis-table-options" :class="['align-' + bottomAlign]" v-if="downloadOptions || bottomPagination">
            <div v-if="downloadOptions" class="download-options">
                <SupsisButton
                    v-if="downloadOptions.downloadTable && downloadEnabled()"
                    ghost
                    @click="$emit('download-table')"
                >
                    <md-icon style="color: black; font-size: 16px !important">cloud_download</md-icon>
                    <span>{{ $t("message.downloadThePage") }}</span>
                </SupsisButton>
                <SupsisButton
                    v-if="downloadOptions.downloadAll && downloadEnabled()"
                    ghost
                    @click="$feature.beforeDownloadExcel(() => $emit('download-all'))"
                >
                    <md-icon style="color: black; font-size: 16px !important">cloud_download</md-icon>
                    <span>{{ $t("message.downloadAllData") }}</span>
                </SupsisButton>
            </div>
            <div style="display: flex; gap: 2px">
                <SupsisButton v-if="tableSettings" ghost @click="$emit('table-settings')">
                    <md-icon style="color: black; font-size: 16px !important">settings</md-icon>
                    <span>{{ $t("message.tableSettings") }}</span>
                </SupsisButton>
                <ve-pagination
                    class="custom-pagination"
                    v-if="bottomPagination"
                    :total="cursor.total"
                    :page-index="cursor.page"
                    :page-size="cursor.perPage"
                    :page-size-option="paginationOptions"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="perPageNumberChange"
                />
            </div>
        </div>
    </div>
</template>
<script>
import SupsisButton from "../views/Pages/Settings/components/SupsisButton.vue";
import { copyText2Clipboard } from "../utils/utils";
import _ from "lodash";
import { mapState } from "vuex";

export default {
    name: "SupsisTable",
    components: { SupsisButton },
    props: {
        columns: {
            type: Array,
            default: () => [],
        },
        attributes: {
            type: Object,
            default: () => ({}),
        },
        rows: {
            type: Array,
            default: () => [],
        },
        emptyDataBordered: {
            type: Boolean,
            default: true,
        },
        topPagination: {
            type: Boolean,
            default: false,
        },
        bottomPagination: {
            type: Boolean,
            default: false,
        },
        paginationCursor: {
            type: Object,
            default: () => ({
                total: 1,
                page: 10,
                perPage: 10,
            }),
        },
        headAlign: {
            type: String,
            default: "right",
        },
        bottomAlign: {
            type: String,
            default: "right",
        },
        paginationOptions: {
            type: Array,
            default: () => [10, 20, 30, 40, 50, 100],
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        downloadOptions: {
            type: Object,
            default: null,
        },
        tableSettings: {
            type: Boolean,
            default: false,
        },
        zebraRow: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapState({
            setting: (state) => state.setting.settings,
            user: (state) => state.auth.user,
        }),
    },
    data: () => ({
        params: {},
        cursor: {
            total: 0,
            page: 1,
            perPage: 10,
        },
        reFormatedColumns: [],
    }),
    methods: {
        isSlotHas(key) {
            return !!this.$slots[key];
        },
        pageNumberChange(number) {
            this.cursor.page = number;
        },
        perPageNumberChange(number) {
            this.cursor.perPage = number;
        },
        downloadEnabled() {
            return !this.setting.maskSensitiveInfo || _.get(this.user, "role.isRoot", false);
        },
    },
    mounted() {
        this.cursor = this.$_.cloneDeep(this.paginationCursor);
        this.params = this.$_.cloneDeep({
            ...this.attributes,
            rowStyleOption: {
                stripe: true,
            },
            rowKeyFieldName: "_id",
            ...this.options,
            clipboardOption: {
                ...(this.options.clipboardOption || {}),
                beforeCopy: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                    const { endColIndex, endRowIndex, startColIndex, startRowIndex } = selectionRangeIndexes;
                    const selectedData = this.rows.slice(startRowIndex, endRowIndex + 1);
                    const cols = this.columns.slice(startColIndex, endColIndex + 1);

                    const result = selectedData
                        .map((row) => {
                            return cols.map((col) => (_.get(row, col.field) || _.get(row, col.key))).join(cols.length > 1 ? "," : "");
                        })
                        .join("\n");
                    copyText2Clipboard(result);

                    this.$message.success("Kopyalandı");
                    return false;
                },
            },
        });
        this.reFormatedColumns = this.columns
            .map((column) => {
                if (column && !column?.align) column.align = "left";
                return column;
            })
            .filter((column) => column);
    },
    watch: {
        paginationCursor: {
            deep: true,
            handler() {
                if (!_.isEqual(this.paginationCursor, this.cursor)) {
                    this.cursor = this.paginationCursor;
                }
            },
        },
        cursor: {
            deep: true,
            handler(newVal) {
                this.$emit("cursor-changed", newVal);
            },
        },
        options: {
            deep: true,
            handler() {
                if (!this.$_.isEqual(this.params, this.options)) {
                    this.params = this.$_.cloneDeep({
                        ...this.attributes,
                        rowStyleOption: {
                            stripe: true,
                        },
                        rowKeyFieldName: "_id",
                        ...this.options,
                        clipboardOption: {
                            ...(this.options.clipboardOption || {}),
                            beforeCopy: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
                                const { endColIndex, endRowIndex, startColIndex, startRowIndex } =
                                    selectionRangeIndexes;
                                const selectedData = this.rows.slice(startRowIndex, endRowIndex + 1);
                                const cols = this.columns.slice(startColIndex, endColIndex + 1);

                                const result = selectedData
                                    .map((row) => {
                                        return cols.map((col) => (_.get(row, col.field) || _.get(row, col.key))).join(cols.length > 1 ? "," : "");
                                    })
                                    .join("\n");
                                copyText2Clipboard(result);

                                this.$message.success("Kopyalandı");
                                return false;
                            },
                        },
                    });
                }
            },
        },
        columns: {
            deep: true,
            handler() {
                if (!this.$_.isEqual(this.reFormatedColumns, this.columns)) {
                    this.reFormatedColumns = this.columns
                        .map((column) => {
                            if (column && !column?.align) column.align = "left";
                            return column;
                        })
                        .filter((column) => column);
                }
            },
        },
    },
};
</script>
<style lang="scss">
.ve-dropdown-popper {
    z-index: 1000 !important;
}

.supsis-table {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

    .supsis-table-empty-data {
        &.bordered {
            border: 1px solid var(--border-neutral-default);
        }

        border-top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ve-table-container {
        &::-webkit-scrollbar {
        }

        &::-webkit-scrollbar-thumb {
            background: #f2f4f7;
        }
    }

    .ve-table.ve-table-border-around {
        border-color: var(--color-bg-neutral-default) !important;
    }

    .ve-table
    .ve-table-container
    .ve-table-content-wrapper
    table.ve-table-content
    tbody.ve-table-body.ve-table-stripe
    tr.ve-table-body-tr:nth-child(2n + 1)
    td {
        background: var(--color-bg-neutral-default) !important;
    }

    &:not(.zebra-row) {
        .ve-table
        .ve-table-container
        .ve-table-content-wrapper
        table.ve-table-content
        tbody.ve-table-body.ve-table-stripe
        tr.ve-table-body-tr
        td {
            background: var(--color-bg-default) !important;
        }
    }

    .ve-table
    .ve-table-container
    .ve-table-content-wrapper
    table.ve-table-content
    thead.ve-table-header
    tr.ve-table-header-tr
    th.ve-table-header-th {
        background: var(--color-bg-neutral-default) !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: var(--default-text-color) !important;
        border-color: var(--color-bg-neutral-default) !important;
    }

    .ve-table
    .ve-table-container
    .ve-table-content-wrapper
    table.ve-table-content
    tbody.ve-table-body
    tr.ve-table-body-tr
    td.ve-table-body-td,
    .ve-table
    .ve-table-container
    .ve-table-content-wrapper
    table.ve-table-content
    tbody.ve-table-body
    tr.ve-table-expand-tr
    td.ve-table-body-td {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background: var(--color-bg-default) !important;
        color: var(--default-text-color) !important;
        border-color: var(--color-bg-neutral-default) !important;
    }

    .ve-pagination {
        background: transparent !important;

        .ve-pagination-total {
            color: var(--default-text-color) !important;
        }

        .ve-pagination-li {
            background: var(--color-bg-neutral-default) !important;
        }

        .ve-dropdown-dt-selected {
            background: var(--color-bg-neutral-default) !important;

            .ve-select-selected-span {
                color: var(--default-text-color) !important;
            }
        }

        .ve-pagination-goto-input {
            background: var(--color-bg-neutral-default) !important;
            color: var(--default-text-color) !important;
        }
    }

    &.expended {
        th,
        td {
            padding: 0 !important;
        }

        .ve-table-header-tr,
        .ve-table-body-tr {
            height: 0 !important;
        }

        .ve-table-header-th,
        .ve-table-body-td {
            padding: 0 !important;
        }
    }

    .supsis-table-options {
        display: flex;
        align-items: center;

        &.align-right {
            justify-content: flex-end;
        }

        &.align-left {
            justify-content: flex-start;
        }

        &.align-space-between {
            justify-content: space-between;
        }

        &.align-center {
            justify-content: center;
        }

        .download-options {
            display: flex;
            align-items: center;
            gap: 3px;
        }
    }
}
</style>
